import { gql } from '@apollo/client';

const GET_SITE_INSPECTION_REPORT = gql`
query generateAllInspectionReports($regionId: Int!, $claimIndx: Int!, $frenchVersion: Boolean, $phaseIndx: Int, $userGuid: UUID, $sendToSymbility: Boolean) {
  generateAllInspectionReports(regionId: $regionId, claimIndx: $claimIndx, frenchVersion: $frenchVersion, phaseIndx: $phaseIndx, userGuid: $userGuid, sendToSymbility: $sendToSymbility)
}`;

export default GET_SITE_INSPECTION_REPORT;